import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MenuBar from './components/MenuBar.tsx';
import Home from './pages/HomePage.tsx';
import Philosophy from './pages/PhilosPage.tsx';
import About from './pages/AboutPage.tsx';
import Contact from './pages/ContactPage.tsx';
import GroupBreathwork from './pages/servicepages/GroupBreathwork.tsx';
import WimHof from './pages/servicepages/WimHof.tsx';
import Community from './pages/servicepages/Community.tsx';
import CacaoSoundBath from './pages/servicepages/CacaoSoundBath.tsx';
import OneonOne from './pages/servicepages/OneOnOne.tsx';
import TravelRetreats from './pages/servicepages/TravelRetreats.tsx';
import Services from './pages/Services.tsx';
import PrivateEvents from './pages/PrivateEvents.tsx';

const App: React.FC = () => {
  return (
    <Router>
      <MenuBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/philosophy" element={<Philosophy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/group-breathwork" element={<GroupBreathwork />} />
        <Route path="/individual-instruction" element={<OneonOne />} />
        <Route path="/wim-hof-workshop" element={<WimHof />} />
        <Route path="/community-breathwork" element={<Community />} />
        <Route path="/cacao-and-sound-bath" element={<CacaoSoundBath />} />
        <Route path="/travel-retreats" element={<TravelRetreats />} />
        <Route path="/private-events" element={<PrivateEvents />} />
      </Routes>
    </Router>
  );
};

export default App;
